import React from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col, Button} from 'react-bootstrap'

export function BackButton({ onClick }) {
  return (
      <Container className='mb-3'>
        <Row>
          <Col>
          <Button className='pl-0 ml-0'
          variant='link'
          onClick={onClick}>
            <i className='fas fa-fw fa-chevron-left' />
            Back
          </Button>
          </Col>
        </Row>
      </Container>
  )
}

BackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default BackButton
